import styled, { css } from "styled-components";
import * as variables from "src/styles/variables.scss";

export const inputStyle = css<InputProps>`
    background-color: ${(props) => props.theme.palette.common.white};
    border: 1px solid ${(props) => (props.error ? props.theme.palette.error.main : variables.colorGray)};
    border-radius: 4px;
    box-sizing: border-box;
    color: ${variables.colorDark};
    display: block;
    font-size: 14px;
    height: 50px;
    margin-bottom: ${(props) => (props.hasError ? "5px" : "0")};
    margin-top: ${(props) => (props.hasLabel ? "5px" : "0")};
    padding: 16px 10px;
    width: 100%;

    ::placeholder {
        color: ${(props) => props.theme.palette.grey[40]};
    }
`;

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: boolean;
    hasError?: boolean;
    hasLabel?: boolean;
}

const Input = styled("input")<InputProps>`
    ${inputStyle};
`;

export default Input;
